import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import Index from '../views/index.vue'

import Login from '../views/auth/login.vue'
import Logout from '../views/auth/logout.vue'

import Dashboard from '../views/dashboard/index.vue'
import Invoice from '../views/invoice/index.vue'
import Specialities from '../views/specialities/index.vue'
import Hunters from '../views/hunters/index.vue'
import Users from '../views/users/index.vue'

import Vouchers from '../views/vouchers/index.vue'
import ProfessionalVisibility from '../views/visibility/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Index,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/specialities',
    name: 'Specialities',
    component: Specialities,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/hunters',
    name: 'Hunters',
    component: Hunters,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/invoice',
    name: 'Invoice',
    component: Invoice,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/vouchers',
    name: 'Users',
    component: Vouchers,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/visibility',
    name: 'Visibility',
    component: ProfessionalVisibility,
    meta: {
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  base: process.env.VUE_APP_BASE_PATH,
  routes,
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['Auth/isLoggedIn']) {
      next('/login')
      return
    }
  } else {
    if (store.getters['Auth/isLoggedIn']) {
      next('/dashboard')
      return
    }
  }

  next()
})

export default router
